export default __webpack_public_path__ + "static/media/general2.68149218.png";